import {useCallback} from 'react'

import {useTrackRefraPlannerEvent, TrackingEvent} from '@refra/modules/common/hooks'
import type {
  AddMaterialInstallationDTO,
  EditMaterialInstallationDTO
} from '@refra/modules/refra-planning/types'

export const useRefraPlanningTracking = () => {
  const trackEvent = useTrackRefraPlannerEvent()

  return {
    materialInstallation: {
      add: useCallback(
        (material: AddMaterialInstallationDTO) => {
          trackEvent({
            name: TrackingEvent.onAddMaterialInstallation,
            refractoryId: material.refractoryId?.toString()
          })
        },
        [trackEvent]
      ),
      edit: useCallback(
        (installationId: string, material: EditMaterialInstallationDTO) => {
          trackEvent({
            name: TrackingEvent.onEditMaterialInstallation,
            installationId: installationId.toString(),
            refractoryId: material.refractoryId?.toString()
          })
        },
        [trackEvent]
      ),
      remove: useCallback(
        (installationId: number) => {
          trackEvent({
            name: TrackingEvent.onRemoveMaterialInstallation,
            installationId: installationId.toString()
          })
        },
        [trackEvent]
      )
    },

    shutdown: {
      add: useCallback(() => {
        trackEvent({
          name: TrackingEvent.onAddShutdown
        })
      }, [trackEvent]),
      edit: useCallback(
        (shutdownId: number) => {
          trackEvent({
            name: TrackingEvent.onEditShutdown,
            shutdownId: shutdownId.toString()
          })
        },
        [trackEvent]
      )
    },

    drilling: {
      add: useCallback(
        (shutdownId: number) => {
          trackEvent({
            name: TrackingEvent.onAddDrilling,
            shutdownId
          })
        },
        [trackEvent]
      ),
      edit: useCallback(
        (shutdownId: number) => {
          trackEvent({
            name: TrackingEvent.onEditDrilling,
            shutdownId
          })
        },
        [trackEvent]
      ),
      remove: useCallback(
        (shutdownId: number) => {
          trackEvent({
            name: TrackingEvent.onDeleteDrilling,
            shutdownId
          })
        },
        [trackEvent]
      )
    }
  }
}
